import { newsApi } from './api';
import {
    DELETE_DRIVER_ENDPOINT,
    DRIVER_EDIT_ENDPOINT,
    DRIVER_STORE_ENDPOINT,
    EDIT_APPLICATION_ENDPOINT,
    EDIT_MODE_ENDPOINT,
    GET_DRIVER_ARCHIVE_ENDPOINT,
    GET_DRIVER_MANAGE_ENDPOINT,
    GET_DRIVER_RECRUITMENT_ENDPOINT,
    GET_DRIVER_STATISTICS_ENDPOINT,
    GET_SELECT_DRIVER_ENDPOINT,
    RESENT_INVITE_ENDPOINT,
    STATUS2_ENDPOINT,
    STATUS_ENDPOINT,
    VIEW_DRIVER_ENDPOINT,
} from "./apiConstant";

export const NotesService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getSelectDrivers: build.query({
            query: () => ({
                url: `${GET_SELECT_DRIVER_ENDPOINT}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: [''],
        }),
        getDriverStatistics: build.query({
            query: (id) => ({
                url: `${GET_DRIVER_STATISTICS_ENDPOINT}/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getDriverManage: build.query({
            query: (pagination) => ({
                url: `${GET_DRIVER_MANAGE_ENDPOINT}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getDriverArchive: build.query({
            query: (pagination) => ({
                url: `${GET_DRIVER_ARCHIVE_ENDPOINT}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        getDriverRecruitment: build.query({
            query: (pagination) => ({
                url: `${GET_DRIVER_RECRUITMENT_ENDPOINT}${pagination && pagination}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        viewDriver: build.query({
            query: (params) => ({
                url: `${VIEW_DRIVER_ENDPOINT}/${params?.id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addDriver: build.mutation({
            query: (form) => ({
                url: `${DRIVER_STORE_ENDPOINT}`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editDriver: build.mutation({
            query: ({ id, newForm }) => ({
                url: `${DRIVER_EDIT_ENDPOINT}/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        removeDriver: build.mutation({
            query: (id) => ({
                url: `${DELETE_DRIVER_ENDPOINT}/${id}`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        resendInvite: build.mutation({
            query: (id) => ({
                url: `${RESENT_INVITE_ENDPOINT}/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editMode: build.mutation({
            query: (id) => ({
                url: `${EDIT_MODE_ENDPOINT}/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editDriverApp: build.mutation({
            query: ({ id, newForm }) => ({
                url: `${EDIT_APPLICATION_ENDPOINT}/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        updateStatus: build.mutation({
            query: (data) => ({
                url: `${STATUS_ENDPOINT}/${data?.id}/${data?.status}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        updateManagementStatus: build.mutation({
            query: (data) => ({
                url: `${STATUS2_ENDPOINT}/${data?.id}/${data?.status}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetSelectDriversQuery,
    useGetDriverStatisticsQuery,
    useGetDriverManageQuery,
    useGetDriverArchiveQuery,
    useGetDriverRecruitmentQuery,
    useViewDriverQuery,
    useAddDriverMutation,
    useEditDriverMutation,
    useRemoveDriverMutation,
    useResendInviteMutation,
    useEditModeMutation,
    useEditDriverAppMutation,
    useUpdateStatusMutation,
    useUpdateManagementStatusMutation,
} = NotesService